import type { TrackingContextValue } from '@ps/web-shared-analytics';
import { TrackingCategory } from '@ps/web-shared-analytics';

export const maxSelectionsInBetSlip = 25;

export const trackingContext = {
  category: TrackingCategory.Sports,
  widget: {
    widgetName: 'Sports Bet Slip Widget',
    widgetId: 'isp-sports-widget-bet-slip',
    widgetContext: 'BET_SLIP'
  }
} as const satisfies TrackingContextValue;
